<template>
  <footer class="main-footer">
    <div class="pull-right hidden-xs">
      <b>Version</b> 1.1
    </div>
    <strong> REKFIX</strong> &copy; 2021 <a href="#"><strong>Automating</strong> Vehicle-related Transaction Flows</a> .
  </footer>
</template>

<script>
  export default {
    name: 'DashboardFooter'
  }
</script>




// WEBPACK FOOTER //
// Footer.vue?595e97c5